import component from "containers/StaticPages/pages/WhySolar";

export default {
  key: "solar",
  title: "solar",
  path: "/:user?/solar",
  pageName: "solar",
  linkTarget: "/solar",
  component,
};
